import { useCMInnovativeSwingExp } from '../hooks/useCMInnovativeSwingExp'
import { Variant1PageContent } from '../pages/Variant1PageContent'
import { Variant2PageContent } from '../pages/Variant2PageContent'

export const CMInnovativeSwingExperiment = ({
  Control,
}: {
  Control: () => React.ReactNode
}) => {
  const { isVariant1, isVariant2 } = useCMInnovativeSwingExp()

  if (isVariant1) return <Variant1PageContent />
  if (isVariant2) return <Variant2PageContent />
  return <Control />
}
